import { DatePicker } from "antd";
import locale from "antd/locale/fr_FR";
import classnames from "classnames";
import Label from "../../../Label";

const { RangePicker } = DatePicker;

const Simple = ({ label, errors, touched, icon, required, ...rest }) => {
  return (
    <div
      className={classnames("datepicker__lmf", {
        __error: touched && errors,
      })}
    >
      <Label label={label} icon={icon} required={required} />
      <div className={`datepicker__lmf--field`}>
        <RangePicker
          locale={locale}
          className={classnames({ "disabled--input": rest.disabled })}
          {...rest}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

export default Simple;
